const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const revealTrustSection = (section) => {
  if (section.dataset.trustAnimationBound === 'true') return;
  section.dataset.trustAnimationBound = 'true';

  if (reducedMotion.matches || !('IntersectionObserver' in window)) {
    section.classList.add('is-visible');
    return;
  }

  section.setAttribute('data-animate-ready', '');
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry?.isIntersecting) return;
      section.classList.add('is-visible');
      observer.disconnect();
    },
    { threshold: 0.18, rootMargin: '0px 0px -30px' }
  );
  observer.observe(section);
};

document.querySelectorAll('[data-trust-animate]').forEach(revealTrustSection);

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector?.('[data-trust-animate]');
  if (section) revealTrustSection(section);
});
